import { StyledComponent } from '@on-arte/ui';
import styled from 'styled-components';

export const FormikForm: StyledComponent<'form'> = styled.form`
  width: 100%;
`;
